// Worklets: the drag gestures edit the strip order on the UI thread, and JS edits (taps,
// accessibility actions, Reset) reuse the same functions so both paths agree.

/**
 * `order` with `destination` moved to (or, when absent, inserted at) `slot` of the result.
 * Out-of-range slots clamp to the ends.
 */
export function placeInPrimaryNavigationStrip<T>(
  order: readonly T[],
  destination: T,
  slot: number,
): T[] {
  "worklet";
  const rest = order.filter((candidate) => candidate !== destination);
  const at = Math.max(0, Math.min(Math.trunc(slot), rest.length));
  return [...rest.slice(0, at), destination, ...rest.slice(at)];
}

/** `order` without `destination`. */
export function removeFromPrimaryNavigationStrip<T>(order: readonly T[], destination: T): T[] {
  "worklet";
  return order.filter((candidate) => candidate !== destination);
}

export function arePrimaryNavigationStripOrdersEqual<T>(
  first: readonly T[],
  second: readonly T[],
): boolean {
  "worklet";
  return (
    first.length === second.length &&
    first.every((destination, index) => destination === second[index])
  );
}
